import { render, staticRenderFns } from "./InformationDetail.vue?vue&type=template&id=5c17d3cc&scoped=true&"
import script from "./InformationDetail.vue?vue&type=script&lang=js&"
export * from "./InformationDetail.vue?vue&type=script&lang=js&"
import style0 from "./InformationDetail.vue?vue&type=style&index=0&id=5c17d3cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17d3cc",
  null
  
)

export default component.exports